import { Box, Typography, Paper } from "@mui/material";

/**
 * 이메일 대량 발송 안내 섹션
 * @description 사용 방법을 안내하는 컴포넌트입니다.
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-15
 */
export const GuideSection = () => {
  return (
    <Paper elevation={0} variant="outlined" sx={{ mb: 3 }}>
      <Box sx={{ p: 3 }}>
        <Typography variant="body1" color="text.secondary" mb={1}>
          💡 <strong>사용 방법:</strong>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          1. CSV 파일 형식: email, name (첫 번째 줄은 헤더로 자동 인식)
          <br />
          2. 회사 ID를 입력하여 해당 회사의 멤버로 등록
          <br />
          3. 임시패스워드가 자동 생성되어 이메일로 발송됩니다
        </Typography>
      </Box>
    </Paper>
  );
};
